import * as React from "react";
const SvgFiRrSoldHouse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sold-house_svg__a)">
      <path
        fill="#062147"
        d="M24 10.478v3.565a1 1 0 1 1-2 0v-3.565c0-.93-.42-1.79-1.151-2.363l-7-5.478a2.99 2.99 0 0 0-3.697 0l-7 5.478a2.99 2.99 0 0 0-1.151 2.363v3.565a1 1 0 1 1-2 0v-3.565A4.97 4.97 0 0 1 1.92 6.54l6.999-5.478a4.99 4.99 0 0 1 6.162 0l7 5.478A4.97 4.97 0 0 1 24 10.478M4.696 19.346c-.56-.227-1.083-.467-1.365-.595-.098-.045-.428-.173-.433-.615-.002-.131.103-.441.515-.577.427-.138.831-.046 1.136.088a.725.725 0 0 0 .862-.224.727.727 0 0 0-.24-1.092c-.549-.278-1.312-.48-2.15-.203a2.16 2.16 0 0 0-1.469 1.794c-.106.817.23 1.563.921 2.047.003 0 .838.409 1.752.779.214.086.904.409.816.958-.065.39-.491.794-1.095.794-.381 0-.752-.106-1.068-.297a.725.725 0 0 0-.887.11.732.732 0 0 0 .119 1.13 3.3 3.3 0 0 0 1.837.552c1.219 0 2.243-.852 2.434-2.026.143-.881-.224-2.034-1.683-2.625zM11.8 18.3v3.4c0 1.269-1.031 2.3-2.3 2.3a2.3 2.3 0 0 1-2.3-2.3v-3.4c0-1.27 1.031-2.3 2.3-2.3s2.3 1.03 2.3 2.3m-1.6 0a.7.7 0 0 0-1.4 0v3.4a.7.7 0 0 0 1.4 0zm12.399 0v3.4a2.3 2.3 0 0 1-2.3 2.3h-1.5a.8.8 0 0 1-.8-.8v-6.401a.8.8 0 0 1 .8-.8h1.5c1.27 0 2.3 1.03 2.3 2.3m-1.6 0a.7.7 0 0 0-.7-.7h-.7v4.802h.7a.7.7 0 0 0 .7-.7V18.3m-4.801 4.1h-1.599v-5.6a.8.8 0 1 0-1.6 0v6.4a.8.8 0 0 0 .8.8H16.2a.8.8 0 1 0-.002-1.6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sold-house_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSoldHouse;
